module.exports = __webpack_public_path__ + "img/white-w-disc-b-case-closed.12005261.svg";